import React from "react";
import styles from "./ProductVideos.module.scss";
import DesignGrid from "../DesignGrid/DesignGrid";
import { productVideoImagesData } from "../designData";

const ProductVideos = () => {
    return (
        <div className={styles.productVideosContainer}>
            <DesignGrid
                data={productVideoImagesData}
                layout={"Landscape"}
            />
        </div>
    );
};

export default ProductVideos;